<template>
  <div id="app">
    <Header/>
    <Background/>
  </div>
</template>

<script>
import Header from './components/Header';
import Background from './components/background';

export default {
  components: {
    Header,
    Background,
  },
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* text-align: right; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
body {
   margin: 0;
   padding: 0;
}
.logo {
  /* background-color: black; */
  margin: 0px;
  /* margin-top: 40px; */
}
h1 {
  margin: 0px; 
  padding-top: 20px;
  padding-bottom: 20px;
}
p {
  margin: 0px;
}
.router-link-exact-active li{
  /* background:red; */
  /* border-bottom: 5px solid white; */
  text-decoration: underline;
}

@media screen and (min-width: 1001px) {
h1 {
  font-size:3vw;
}
}
@media screen and (max-width: 1000px) {
h1 {
  font-size:5vw;
}
}
</style>
